import * as storeConst from "./constants";
import { makeCall, handleProgramServiceError } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";

export const state = {
  biometricData: {
    [storeConst.LIST_BIOMETRIC_CATEGORIES.SYSTOLIC_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.DIASTOLIC_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.WAIST_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.TC_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.HDL_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.TRIGLYCERIDES_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.FAST_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.NON_FAST_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.BMI_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.TC_HDL_CODE]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    },
    [storeConst.LIST_BIOMETRIC_CATEGORIES.A1C]: {
      femaleMin: 0,
      femaleMax: 0,
      maleMin: 0,
      maleMax: 0,
      unidentifiedMin: 0,
      unidentifiedMax: 0
    }
  }
};

export const getters = {
  [storeConst.GETTERS_LIST_BIOMETRIC_DATA]: state => {
    return state.biometricData;
  }
};

export const actions = {
  [storeConst.ACTIONS_GET_LIST_BIOMETRIC_DATA]: ({ commit }, options) => {
    const url = getEndPoints().programBiometric.getAll;
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        commit(storeConst.MUTATIONS_SET_LIST_BIOMETRIC_DATA, response);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  }
};

export const mutations = {
  [storeConst.MUTATIONS_SET_LIST_BIOMETRIC_DATA]: (state, payload) => {
    if (payload) {
      let result = Object.assign({}, state.biometricData);
      payload.data.forEach(item => {
        result[item.biometricCode] = item;
      });
      state.biometricData = result;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_biometric_data/index.js